import { NativeModule } from "expo";

import type {
  ChangeEventPayload,
  TopShelfContent,
} from "./ExpoTvosTopShelf.types";

type ExpoTvosTopShelfModuleEvents = {
  onChange: (params: ChangeEventPayload) => void;
};

class ExpoTvosTopShelfModule extends NativeModule<ExpoTvosTopShelfModuleEvents> {
  async setContentAsync(_: TopShelfContent, __?: string): Promise<void> {
    // noop
  }

  async clearContentAsync(_?: string): Promise<void> {
    // noop
  }

  async notifyContentChangedAsync(): Promise<void> {
    // noop
  }
}

export default new ExpoTvosTopShelfModule();
